import { InjectionToken } from '@angular/core';

import { AppRoutes } from '@gfe/app.paths';

import { environment } from '../../../environments/environment';

export const GALIA_BASE_URL = new InjectionToken<string>('GALIA_BASE_URL', {
  providedIn: 'root',
  factory: () => environment.galiaUrl
});

// Popup windows open on the page's own origin, not environment.galiaUrl: they need the opener's
// BroadcastChannel and session, which another origin does not share.
export const GALIA_POPUP_DATA_VISUALIZATION_URL = new InjectionToken<string>(
  'GALIA_DATA_VISUALIZATION_URL',
  {
    providedIn: 'root',
    factory: () => `/${AppRoutes.dataVisualizationPopup.root}`
  }
);

export const GALIA_ASSISTANT_WINDOW_URL = new InjectionToken<string>(
  'GALIA_ASSISTANT_WINDOW_URL',
  {
    providedIn: 'root',
    factory: () => `/${AppRoutes.assistantWindow.root}`
  }
);
